import { ConfirmDialog } from '@/components/confirm/ConfirmDialog'

interface ZipConfirmDialogProps {
	open: boolean
	/** The COMPLETE selected count, which is what the archive will contain. */
	selectedCount: number
	submitting: boolean
	/** Safe, pre-formatted copy for a refused request. This dialog is the only surface that reports it. */
	errorMessage: string | null
	onCancel: () => void
	onConfirm: () => void
}

/**
 * The ZIP pre-flight confirmation: the existing `ConfirmDialog` with this
 * feature's copy, and nothing else.
 *
 * Not a second dialog primitive — it exists so the copy is storied and so the
 * page does not carry it inline. Unlike the delete confirmation beside it, this
 * one closes on ACCEPTANCE rather than as the request goes out: until the
 * backend has taken the work there is nothing to have accepted, and this dialog
 * is where a refusal is reported. It never shows generation progress: once the
 * request is accepted it is gone, and the work is followed elsewhere.
 */
export function ZipConfirmDialog({
	open,
	selectedCount,
	submitting,
	errorMessage,
	onCancel,
	onConfirm,
}: ZipConfirmDialogProps) {
	return (
		<ConfirmDialog
			open={open}
			title="Prepare a ZIP?"
			description={`${selectedCount} ${
				selectedCount === 1 ? 'file' : 'files'
			} will be packaged. This may take several minutes — you can keep working, and you will be told when it is ready.`}
			confirmLabel="Generate ZIP"
			busyLabel="Requesting…"
			submitting={submitting}
			errorMessage={errorMessage}
			onCancel={onCancel}
			onConfirm={onConfirm}
		/>
	)
}
